// extracted by mini-css-extract-plugin
export var aggregationCell = "_2k-o";
export var aggregationRow = "_2k-n";
export var borderlessSpinnerContainer = "_2k-3";
export var cardLayout = "_2k-6";
export var cardLayoutNoFooter = "_2k-9";
export var cardLayoutPageControl = "_2k-8";
export var closeIcon = "_2k-g";
export var columnHeaderSurface = "_2k-c";
export var columnHeaderSurfaceDragOverlay = "_2k-w";
export var columnHeaderSurfaceResizing = "_2k-t";
export var contextMenuAnchor = "_2k-1";
export var draggableColumnHeader = "_2k-u";
export var draggableColumnHeaderOverlay = "_2k-v";
export var expandIcon = "_2k-h";
export var expanded = "_2k-i";
export var filterDropdown = "_2k-j";
export var filterDropdownDivider = "_2k-e";
export var filterDropdownHeader = "_2k-m";
export var filterDropdownItem = "_2k-l";
export var filterDropdownModal = "_2k-k _2k-j";
export var filterItem = "_2k-d";
export var normalCellWithAdjustableBorder = "_2k-f";
export var pinButtonContainer = "_2k-p";
export var pinIcon = "_2k-q";
export var pinIconActive = "_2k-r";
export var spinner = "_2k-0";
export var spinnerContainer = "_2k-2";
export var tableContainer = "_2k-4";
export var tableContentDraggingColumns = "_2k-b";
export var tableContentInner = "_2k-7";
export var tableContentInnerFill = "_2k-a";
export var tableContentWrapper = "_2k-5";
export var viewButtonContainer = "_2k-s";